import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string) {
    // const encodedContent = encodeURIComponent(url);
    // const dataUrl = `data:text/html;charset=utf-8,${encodedContent}`;

   // return this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
   return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
